export default [
  {
    path: '/app/hr-forms',
    name: 'HrForms',
    component: () => import('@/views/Admin/HrForms/Index.vue'),
    meta: {
      pageTitle: 'Başvuru Formları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_HR_POSITIONS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/hr-forms/view/:id',
    name: 'HrForms',
    component: () => import('@/views/Admin/HrForms/View.vue'),
    meta: {
      pageTitle: 'Başvuru Formları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/hr-forms',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'ADMIN_HR_POSITIONS_LIST',
      action: 'read',
    },
  },
]
